module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAgCAYAAAC7FpAiAAAAr0lEQVRYR2NkmBmRxvD/fyQDmeBxzNRnMtzCUuRo///9O+MlP+//5OgF62FkOGWwe385I8PM8HYGBoYKcg16nzD3kgAbtx45+v99//7vsr8PEzl6QXr+MzBsN9y9z2vUE6DQGI2J0eQ0midQy5LRPDGaJ0bzxGieQAmB0WbHaNsJrck5Wk+M1hOj9cRoPTFaT6D3xUf72MghMlpPjNYTo/XEaD0xWk8M93pi6A/tAwDD28IwAuugqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/c100.png
// module id = jroa
// module chunks = 18